import { useTranslation } from 'react-i18next';

import FooterLogo from '@/assets/img/logo/logo.png';
import * as S from '@/components/Footer/style';
import useIsMobile from '@/hooks/useIsMobile';

import LineIcon from '../Icon/lineIcon';

const Footer = () => {
	const { t } = useTranslation();
	const isMobile = useIsMobile(1225);
	return (
		<S.FooterContainer>
			<S.FooterWrapper>
				<S.FooterContent>
					<S.ImgBox>
						<img src={FooterLogo} alt={t('common.logo.alt')} decoding="async" />
					</S.ImgBox>
					<S.FooterAbout>
						<S.ContentBox>
							<S.FooterContact>
								<S.FooterInfo>{t('법인명: 사단법인 한국응용과학기술학회')}</S.FooterInfo>
								{!isMobile && <LineIcon width="2" height="12" iconColor="#ADB5BD" />}
								<S.FooterInfo>{t('대표자: 양재찬')}</S.FooterInfo>
								{!isMobile && <LineIcon width="2" height="12" iconColor="#ADB5BD" />}
								<S.FooterInfo>{t('사업자등록번호: 108-82-07074')}</S.FooterInfo>
								{!isMobile && <LineIcon width="2" height="12" iconColor="#ADB5BD" />}
								<S.FooterInfo>{t('주소: [35349]대전 서구 도안북로 88, 목원대학교, C관 106호')}</S.FooterInfo>
								{!isMobile && <LineIcon width="2" height="12" iconColor="#ADB5BD" />}
								<S.FooterInfo>TEL: 042-829-7578</S.FooterInfo>
							</S.FooterContact>
						</S.ContentBox>
						<S.CopyRight>{t('COPYRIGHT © 한국응용과학기술학회 ALL RIGHT RESERVED.')}</S.CopyRight>
					</S.FooterAbout>
				</S.FooterContent>
			</S.FooterWrapper>
		</S.FooterContainer>
	);
};

export default Footer;
